import { LinkContent } from "./icon-links.types";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBandcamp, faInstagram } from '@fortawesome/free-brands-svg-icons'

export const links: LinkContent[] = [
  {
    ariaLabel: 'Bandcamp',
    icon: <FontAwesomeIcon icon={faBandcamp} />,
    url: 'https://carlhauck.bandcamp.com/',
  },
  {
    ariaLabel: 'Instagram',
    icon: <FontAwesomeIcon icon={faInstagram} />,
    url: 'https://www.instagram.com/carlhauck',
  },
];
